// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__1qzCB","large":"logo_large__nvnZD","logoImage":"logo_logoImage__1rnDa","medium":"logo_medium__eVFtv","footerLogo":"logo_footerLogo__28Oli"};